module.exports = __webpack_public_path__ + "static/img/app-logo.65530c4a.png";